import { Link } from '@tanstack/react-router';

import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import DescriptionIcon from '@mui/icons-material/Description';

import { FormattedMessage } from 'react-intl';

import Inset from '~/modules/ui-kit/spacings/inset';
import ContentView from '~/components/ContentView';
import DrawerButton from '~/containers/DrawerButton';
import { ReactComponent as TermsDocument } from '~/terms.md';
import messages from './messages';

export const TermsOfUse = () => {
  const theme = useTheme();

  return (
    <ContentView
      header={
        <AppBar position="static">
          <Toolbar>
            <DrawerButton />
            <Typography variant="h6" style={{ marginLeft: theme.spacing(2) }}>
              <FormattedMessage {...messages.title} />
            </Typography>
          </Toolbar>
        </AppBar>
      }
    >
      <Inset>
        <TermsDocument />
        <Link to="/privacy">
          <Button startIcon={<DescriptionIcon />}>
            <FormattedMessage {...messages.privacyPolicy} />
          </Button>
        </Link>
      </Inset>
    </ContentView>
  );
};

TermsOfUse.displayName = 'TermsOfUse';

export default TermsOfUse;
